// Copyright (c) 2020 Deere & Company

import {
    getRgaAnalysisStatusDropDown,
    getRgaRequestorTypeDropDown,
    getRgaStatusDropDown,
    getRgaUnitsDropDown
} from '../../shared/rga-domain-values/action-creators/rga-domain-values';
import {
    onSearch,
    openMassUpdateModal,
    openMassUploadModal,
    updateSearchByDropDown,
    updateSearchQueryString
} from './search';
import {
    resetRgaSearchModelObject,
    resetRgaSearchObjectDateValues,
    resetRgaSearchObjectListValues,
    resetRgaSearchObjectValues,
    setRequestedDate,
    updateRgaSearchObject,
    updateRgaSearchObjectDDValues,
    updateRgaSearchObjectListValues
} from './rga-search';
import {
    resetRgaSearchSelectedDomains,
    updateSelectDomainValue
} from './select-domains';

export default {
    getRgaAnalysisStatusDropDown,
    getRgaRequestorTypeDropDown,
    getRgaStatusDropDown,
    getRgaUnitsDropDown,
    onSearch,
    openMassUpdateModal,
    openMassUploadModal,
    resetRgaSearchModelObject,
    resetRgaSearchObjectDateValues,
    resetRgaSearchObjectListValues,
    resetRgaSearchObjectValues,
    resetRgaSearchSelectedDomains,
    setRequestedDate,
    updateRgaSearchObject,
    updateRgaSearchObjectDDValues,
    updateRgaSearchObjectListValues,
    updateSearchByDropDown,
    updateSearchQueryString,
    updateSelectDomainValue
};



// WEBPACK FOOTER //
// ./src/rga/search/action-creators/index.js